import { Card, Typography, Tree, Space } from "antd";
import type { DataNode, TreeProps } from "antd/es/tree";
import { useBlog } from "api/blog";
import { useScrollSpy } from "hooks/useScrollSpy";
import { FC, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { IBlogSection, checkSection, convertToSnakeCase } from "utils/blog";

const SectionList: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useBlog({ id }, { enabled: !!id });

  const generateSections = (content: string) => {
    const div = document.createElement("div");
    div.innerHTML = content;
    const children = div.children;
    const sections: IBlogSection[] = [];
    const headings = ["H1", "H2", "H3", "H4", "H5", "H6"];
    Array.from(children).forEach((child, index) => {
      if (headings.includes(child.tagName)) {
        checkSection(
          {
            title: child.textContent ?? "",
            hash: `${convertToSnakeCase(child.textContent ?? "")}_${index}`,
            type: child.tagName,
            children: [],
          },
          sections
        );
      }
    });
    div.remove();
    return sections;
  };

  const sectionsTreeData: any = useMemo(() => {
    if (!data?.content) {
      return [];
    }
    const generatedSections = generateSections(data.content);
    const dataTree: DataNode[] = [];
    const ids: string[] = [];
    const convertToDataNode = (
      sections: IBlogSection[],
      dataTree: DataNode[]
    ) => {
      sections.forEach((section) => {
        const item = {
          title: (
            <Link to={`#${section.hash}`}>
              <Typography.Paragraph
                ellipsis={{ rows: 2, expandable: false }}
                style={{ marginBottom: "unset" }}
              >
                {section.title}
              </Typography.Paragraph>
            </Link>
          ),
          key: section.hash,
          children: [],
        };
        dataTree.push(item);
        ids.push(section.hash);
        if (section.children) {
          convertToDataNode(section.children, item.children);
        }
      });
    };
    convertToDataNode(generatedSections, dataTree);
    return { dataTree, ids };
  }, [data]);

  const activeId = useScrollSpy(sectionsTreeData.ids, 150);

  return (
    <Card>
      <Space direction="vertical" size={12}>
        <Typography>On this page</Typography>
        <Tree
          defaultExpandAll
          treeData={sectionsTreeData.dataTree}
          selectedKeys={[activeId]}
        />
      </Space>
    </Card>
  );
};

export default SectionList;
